export const anonymousMemberId = '000000000000000000000000';

export const timeouts = {
  hideInput: 1000,
  showInput: 700,
  showNextMessage: 700,
};
